<template>
  <div v-if="resultsList.length">
    <ul>
      <li v-for="(item, index) in resultsList" :key="index" class="results">
        <b-row>
          <b-col cols="3" class="results__img"
            :style="{ backgroundImage: `url(${domain}/${item.photo})` }">
          </b-col>
          <b-col cols="8" offset="1" class="align-self-center">
            <h3> {{item.title}} </h3>
            <p v-if="type === 'articles'" class="results__content"
              v-html="$options.filters.shortContent(item.body, contentLimit)"></p>
            <p v-else class="results__content">{{ item.body }}</p>
            <div v-if="type === 'articles'">
              <router-link v-if="item.category_name === 'What I need to know'"
                v-scroll-to="'#scrollToOnLoad'"
                :to="{ path: `/need_to_know/${item.id}`}"
                tag="button" class="btn btn-primary btn-sm">
                Read more
              </router-link>
              <router-link v-else
                v-scroll-to="'#scrollToOnLoad'"
                :to="{ path: `/i_love_science/${item.id}`}"
                tag="button" class="btn btn-primary btn-sm">
                Read more
              </router-link>
            </div>
          </b-col>
        </b-row>
      </li>
    </ul>
  </div>
  <p v-else class="results__info">No matched results</p>
</template>

<script>
import filters from '@/utils/filters';

export default {
  props: ['resultsList', 'type'],
  data() {
    return {
      contentLimit: 200,
      domain: process.env.SERVER_URL,
    };
  },
  filters: {
    shortContent: filters.shortContent,
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.results {
  width: 100%;
  padding: 0 50px;
  margin: 50px 0;
  &__img {
    min-height: 250px;
    background-size: cover;
    background-position: center;
  }
  &__content {
    font-size: 16px;
    line-height: 1.5;
  }
  &__info {
    padding: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/ResultsList.vue